import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetPassRequest: '[PASSREQUEST] SET_PASS_REQUEST',
};

export const initialSetPasswordRequest = {
	passwordRequest: false,
};

const initialState = {
	passwordRequest: false,
};

export const reducer = persistReducer(
	{ storage, key: 'passwordRequest', whitelist: ['passwordRequest'] },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetPassRequest:
				return { ...state, passwordRequest: action.payload };

			default:
				return state;
		}
	}
);

export const actions = {
	SetPassRequest: (data) => ({
		type: actionType.SetPassRequest,
		payload: data,
	}),
};
